import React, { useEffect } from 'react';
import { Container, Col, Row } from 'react-bootstrap';
import { Card, CardContent } from '@mui/material';
import PropTypes from 'prop-types';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import BackNext from '../../../Common/SubComponents/BackNext';

export default function Verify(props) {
  const { register, setValue } = useForm({
    resolver: yupResolver(Verify.ValidationSchema),
    mode: 'all',
    reValidateMode: 'all',
    defaultValues: props.formState,
  });

  useEffect(() => {
    // manually register fields for validation that don't play nice with react-hook-form register
    register('socialSecurityNumber');
    setValue('socialSecurityNumber', props.formState.socialSecurityNumber);
  }, [register]);

  return (
    <Container>
      <form className="quote-form" onSubmit={props.onNext}>
        <Row className="justify-content-center">
          <Col lg={6}>
            <div className="formPageTitle">Verify Information</div>

            <p className="verifyText">
              Please verify all of the information below. Any incorrect information can result in application delays and even the need to re-apply.
            </p>
            <p className="verifyText">
              To protect your data, all parties must authenticate when accessing the application to sign or view status. You must provide a date of birth and the last 4
              digits of the social security number for each party.
            </p>
            <p className="verifyText">If any of the information below is incorrect, please use the BACK button to go back and correct it.</p>
          </Col>
        </Row>

        <Row className="justify-content-center">
          <Col lg={5} className='w-100'>
            <Card>
              <CardContent>
                <p className="verifyName" id="insured-name" name="insured-name">
                  {props.formState.pages.insuredInfo.firstName} {props.formState.pages.insuredInfo.lastName}
                </p>

                <p className="verifyText" id="birthdate" name="birthdate">{props.formState.pages.basicInfo.birthdate}</p>

                <p className="verifyTop" id="security-title" name="security-title" >Last 4 digits of Social Security #</p>
                <p className="verifyBottom" id="security-number" name="security-number">{props.formState.pages.insuredInfo.socialSecurityNumber.substring(7, 11)}</p>

                <p className="verifyTop" id="license-title" name="license-title">Driver's License / ID #</p>
                <p className="verifyBottom" id="driver-license" name="driver-license">{props.formState.pages.insuredInfo.driversLicense}</p>

                <p className="verifyTop" id="address-title" name="address-title">Address</p>
                <p className="verifyBottom" id="address" name="address">{props.formState.pages.insuredInfo.streetAddress}</p>

                <p className="verifyTop" id="city-state-title" name="city-state-title">City, State</p>
                <p className="verifyBottom" id="city-state" name="city-state">
                  {props.formState.pages.insuredInfo.city}, {props.formState.pages.insuredInfo.state}
                </p>
              </CardContent>
            </Card>

            <div className="pt-3">
              <BackNext onBack={props.onBack} />
            </div>
          </Col>
        </Row>
      </form>
    </Container>
  );
}

Verify.propTypes = {
  onNext: PropTypes.func.isRequired,
  onBack: PropTypes.func.isRequired,
};
